import { SlotStatus } from 'app/model/CORE';
import { ModalPanelProps } from '../DashboardModal';
import React, { PureComponent } from 'react';
import { Button, Form, Input, Select } from 'antd';
import InputTime from 'app/common/input/InputTime';
import ConditionalRender from 'app/common/components/ConditionalRender';
import TimeUtils from 'app/common/util/TimeUtils';
import { Flex } from 'app/components/common/Flex';
import AppContext from 'app/common/context/AppContext';

interface CreateNewSlotValues {
    slotTime: Date;
    state: SlotStatus;
    aircraftId?: string;
}

interface CreateNewSlotPanelProps extends ModalPanelProps {
    onSuccess: (v: CreateNewSlotValues) => void;
}

interface CreateNewSlotPanelState {
    values: CreateNewSlotValues;
}

export class CreateNewSlotPanel extends PureComponent<CreateNewSlotPanelProps, CreateNewSlotPanelState> {
    constructor(props) {
        super(props);

        this.state = {
            values: {
                slotTime: TimeUtils.addMinutes(AppContext.getCurrentTime(), 10),
                state: SlotStatus.AVAILABLE,
            },
        };
    }

    handleFinish = (values: CreateNewSlotValues) => {
        this.props.onSuccess(values);
        this.props.onClose();
    };

    render() {
        return (
            <Form
                style={{ padding: '1em' }}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 12 }}
                initialValues={this.state.values}
                onFinish={this.handleFinish}
                onValuesChange={(_, v) => this.setState({ values: v })}>
                <Form.Item
                    label="Slot time:"
                    name="slotTime"
                    rules={[
                        {
                            required: true,
                            validator: async (_, slotTime) => {
                                const refTime = TimeUtils.mergeDateAndTime(AppContext.getMonitoredDay(), slotTime);
                                if (TimeUtils.diffInMinutesUpper(refTime, AppContext.getCurrentTime()) < 10) {
                                    return Promise.reject(new Error('Slot time must be 10 minutes in the future'));
                                }
                            },
                        },
                    ]}>
                    <InputTime />
                </Form.Item>
                <Form.Item label="State:" name="state" rules={[{ required: true }]}>
                    <Select>
                        <Select.Option value={SlotStatus.AVAILABLE}>Not Blocked</Select.Option>
                        <Select.Option value={SlotStatus.PRE_ALLOCATED}>Booked</Select.Option>
                        <Select.Option value={SlotStatus.ALLOCATED}>Blocked</Select.Option>
                    </Select>
                </Form.Item>
                <ConditionalRender condition={this.state.values.state === SlotStatus.ALLOCATED}>
                    <Form.Item
                        label="Aircraft Id:"
                        name="aircraftId"
                        rules={[{ required: true, message: 'Please enter an aircraft id' }]}>
                        <Input />
                    </Form.Item>
                </ConditionalRender>
                <Flex style={{ justifyContent: 'center' }}>
                    <Button htmlType="submit">Submit</Button>
                </Flex>
            </Form>
        );
    }
}
